import { useCallback, useEffect, useState } from 'react'

import { useStores } from '../../../../../data/store'
import { LimitTableComp } from './LimitTableComp'

const createEntityFlowList = [{ current: '' }, { current: '' }, { current: '' }, { current: '' }]

const LimitsTable = ({ isSearchFlow, isEdit, entityId }: any) => {
  const { getMasRiskSettingsLimitsData } = useStores((store) => ({
    getMasRiskSettingsLimitsData: store.getMasRiskSettingsLimitsData,
  }))

  console.log('LimitsTable isSearchFlow, isEdit', isSearchFlow, isEdit)

  const [value, setValue] = useState('Open Loop')
  const [selectedData, setSelectedData] = useState(null)
  const [dataList, setDataList] = useState([])

  const onRowPress = useCallback((data) => {
    setSelectedData(data?.parentId ?? data?.groupId)
  }, [])

  useEffect(() => {
    setDataList(getMasRiskSettingsLimitsData(entityId, value === 'Open Loop' ? 'OPEN_LOOP_RISK' : 'CLOSED_LOOP_RISK'))
  }, [dataList.length, entityId, getMasRiskSettingsLimitsData, value])

  return (
    <LimitTableComp
      selectedLoop={value}
      loopData={[
        { id: 1, value: 'Open Loop' },
        { id: 2, value: 'Close Loop' },
      ]}
      onLoopChange={setValue}
      dataList={isSearchFlow ? dataList : createEntityFlowList}
      onRowPress={onRowPress}
      selectedData={selectedData}
      isSearchFlow={isSearchFlow as any}
    />
  )
}
export { LimitsTable }
